import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { useProductDetailSlots } from "../../../../../../../../../../slots/slots/context.js";
import { useProductData } from "../../../../../../../../../../context/context/product-context-hooks.js";
import { useCLEcommContext } from "../../../../../../../context/modules/EcommContent/ContactLensesEcommContent/context/CLEcommContext.js";
const CLDeliveryIndicator = () => {
  const { getLabel } = useIntl();
  const { Slots } = useProductDetailSlots();
  const { activeVariant } = useProductData();
  const { state, selectors } = useCLEcommContext();
  const { configurator, configurations, queries } = state;
  const isOneColConfigurator = selectors.isOneColConfigurator(state);
  const isLoading = !!selectors.hasQueryLoading(state);
  const hasNonOrderableProduct = selectors.hasNonOrderableProduct(state);
  let deliveryItems = [];
  if (hasNonOrderableProduct) {
    deliveryItems = [];
  } else if (isOneColConfigurator) {
    if (queries.both.sku && configurator.both.isEnabled) {
      deliveryItems.push({ sku: queries.both.sku, quantity: configurations.both.quantity });
    }
  } else {
    if (queries.left.sku && configurator.left.isEnabled) {
      deliveryItems.push({ sku: queries.left.sku, quantity: configurations.left.quantity });
    }
    if (queries.right.sku && configurator.right.isEnabled) {
      deliveryItems.push({ sku: queries.right.sku, quantity: configurations.right.quantity });
    }
  }
  return Slots.DynamicDeliveryIndicator ? /* @__PURE__ */ React.createElement(
    Slots.DynamicDeliveryIndicator,
    {
      showLoader: isLoading,
      deliveryItems,
      isExcludedFromCheckout: activeVariant.isExcludedFromCheckout,
      fallbackLabel: getLabel("products.deliveryIndicator.selectPrescription")
    }
  ) : null;
};
export {
  CLDeliveryIndicator
};
//# sourceMappingURL=CLDeliveryIndicator.js.map
